import { z } from "zod";

export const MetaDataSchema = z.object({
	page: z.number(),
	limit: z.number(),
	itemCount: z.number(),
	pageCount: z.number(),
	hasPreviousPage: z.boolean(),
	hasNextPage: z.boolean(),
	/**
	 * `itemCount` is the server's count cap, not the real total — there are more rows than it
	 * reports. Render the figure as "N+" and never as an exact total (PREC-3953). Optional so
	 * responses from endpoints that predate the flag still parse.
	 */
	isCapped: z.boolean().optional(),
});

export const ApolloMetaDataSchema = z.object({
	page: z.number(),
	per_page: z.number(),
	total_entries: z.number(),
	total_pages: z.number(),
});

export type MetaData = z.infer<typeof MetaDataSchema>;
